import { Setting, SettingProps } from "../../setting/models/Setting";

export interface WithSettingsConstructor {
  settings?: SettingProps[];
}

export class WithSettings {
  public readonly settings: Setting[];

  constructor(data: WithSettingsConstructor) {
    this.settings = data.settings?.map((setting) => new Setting(setting)) ?? [];
  }
}
